import { ReactNode } from 'react';

import { usePermissionCheck } from 'common/hooks/usePermissionCheck/usePermissionCheck';

const PermissionCheck = ({ children }: { children: ReactNode }) => {
  const isPermitted = usePermissionCheck();

  return isPermitted ? <>{children}</> : null;
};

export default PermissionCheck;
